import dayjs from 'dayjs'
import { Dayjs } from 'dayjs'

import { DefaultValueType } from 'appRedux/actions/report/report-actionTypes'

const convertDefaultDate = (defaultDate: DefaultValueType, system_date: string): Dayjs | null => {
    switch (defaultDate) {
        case 'TODAY':
            return dayjs(system_date)
        case 'TOMORROW':
            return dayjs(system_date).add(1, 'day')
        case 'YESTERDAY':
            return dayjs(system_date).subtract(1, 'day')
        case 'NEXT_7_DAYS':
            return dayjs(system_date).add(7, 'day')
        case 'NEXT_30_DAYS':
            return dayjs(system_date).add(30, 'day')
        case 'LAST_7_DAYS':
            return dayjs(system_date).subtract(7, 'day')
        case 'LAST_30_DAYS':
            return dayjs(system_date).subtract(30, 'day')
        case 'NEXT_MONTH':
            return dayjs(system_date).add(1, 'month')
        case 'LAST_MONTH':
            return dayjs(system_date).subtract(1, 'month')
        case 'NEXT_WEEK':
            return dayjs(system_date).add(1, 'week')
        case 'LAST_WEEK':
            return dayjs(system_date).subtract(1, 'week')
        case 'START_OF_MONTH':
            return dayjs(system_date).startOf('month')
        case 'END_OF_MONTH':
            return dayjs(system_date).endOf('month')
        case 'START_OF_YEAR':
            return dayjs(system_date).startOf('year')
        case 'END_OF_YEAR':
            return dayjs(system_date).endOf('year')
        case 'START_OF_DAY':
            return dayjs(system_date).startOf('day')
        case 'END_OF_DAY':
            return dayjs(system_date).endOf('day')
        default:
            return null
    }
}

export { convertDefaultDate }